"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
Object.defineProperty(exports, "FeaturedTopicsManager", {
  enumerable: true,
  get: function get() {
    return _FeaturedTopicsManager.default;
  }
});

var _FeaturedTopicsManager = _interopRequireDefault(require("./widget-featured-topics/FeaturedTopicsManager"));